import { fetchAPI } from '../client';

/**
 * Buscar TODAS as mensagens globais da instância com paginação.
 * Retorna um Map<chatid, mensagens[]> para distribuição eficiente.
 */
export async function fetchAllMessagesGlobal(instanceName: string): Promise<Map<string, any[]>> {
    const allMessages: any[] = [];
    let offset = 0;
    const pageSize = 1000;
    let hasMore = true;
    let pageCount = 0;
    const maxPages = 100; // 100.000 mensagens globais (era 10.000)

    console.log(`[History Sync] 🌐 Buscando TODAS as mensagens globais da instância...`);

    while (hasMore && pageCount < maxPages) {
        pageCount++;
        try {
            const data = await fetchAPI<any>('message/find', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'instance': instanceName },
                body: JSON.stringify({ limit: pageSize, offset })
            }, 1);

            const dataKeys = data ? Object.keys(data) : [];
            const isArray = Array.isArray(data);
            console.log(`[History Sync] 📦 Formato resposta P${pageCount}: isArray=${isArray}, keys=[${dataKeys.join(',')}], ` +
                `messages=${data?.messages?.length ?? 'N/A'}, chats=${data?.chats?.length ?? 'N/A'}`);

            let pageMessages: any[] = [];
            if (data?.messages && Array.isArray(data.messages)) pageMessages = data.messages;
            else if (data?.chats && Array.isArray(data.chats)) pageMessages = data.chats;
            else if (data?.messages?.records && Array.isArray(data.messages.records)) pageMessages = data.messages.records;
            else if (data?.data?.messages && Array.isArray(data.data.messages)) pageMessages = data.data.messages;
            else if (data?.data && Array.isArray(data.data)) pageMessages = data.data;
            else if (Array.isArray(data)) pageMessages = data;

            allMessages.push(...pageMessages);
            hasMore = pageMessages.length >= pageSize;
            offset += pageSize;
        } catch {
            break;
        }
    }

    console.log(`[History Sync] 🌐 Total: ${allMessages.length} msgs em ${pageCount} páginas`);

    // Agrupa por chatid
    const groupedMap = new Map<string, any[]>();
    for (const msg of allMessages) {
        const chatid = msg.chatid || msg.key?.remoteJid || '';
        if (!chatid) continue;
        if (!groupedMap.has(chatid)) groupedMap.set(chatid, []);
        groupedMap.get(chatid)!.push(msg);
    }

    return groupedMap;
}
